import React from "react";
import { dadosDetronic, limparMoeda } from "../utils/Utils";
import Facebook from "./svg/Facebook";
import Instagram from "./svg/Instagram";
import Linkedin from "./svg/Linkedin";
import Youtube from "./svg/Youtube";

export default function FooterLandingPage({ data }) {
    return (
        <footer style={{ backgroundColor: "#fff" }}>
            <div className="footer-landing-page">
                <div>
                    <img className="img-footer-landing-page" src={data?.logo ? data?.logo?.url : "/images/logo-white.svg"} alt="Logo" />

                    <div className="container-redes-sociais">
                        <a href={data?.plp_contato_facebook ? data?.plp_contato_facebook : dadosDetronic.facebook} target="_blank" rel="noopener noreferrer" className="container-rede-social">
                            <Facebook fill={data?.plp_cor_principal_escura} />
                        </a>

                        <a href={data?.plp_contato_instagram ? data?.plp_contato_instagram : dadosDetronic.instagram} target="_blank" rel="noopener noreferrer" className="container-rede-social">
                            <Instagram fill={data?.plp_cor_principal_escura} />
                        </a>

                        <a href={data?.plp_contato_linkedin ? data?.plp_contato_linkedin : dadosDetronic.linkedin} target="_blank" rel="noopener noreferrer" className="container-rede-social">
                            <Linkedin fill={data?.plp_cor_principal_escura} />
                        </a>

                        <a href={data?.plp_contato_youtube ? data?.plp_contato_youtube : dadosDetronic.youtube} target="_blank" rel="noopener noreferrer" className="container-rede-social">
                            <Youtube fill={data?.plp_cor_principal_escura} />
                        </a>
                    </div>
                </div>

                <div className="container-outras-informacoes">
                    <a href={data?.plp_contato_telefone ? `tel:+55${limparMoeda(data?.plp_contato_telefone)}` : `tel:+55${limparMoeda(dadosDetronic.telefone)}`} target="_blank" rel="noopener noreferrer">
                        Telefone: +55 {data?.plp_contato_telefone ?? dadosDetronic.telefone}
                    </a>

                    <a href={`https://wa.me/55${data?.plp_contato_whatsapp ? limparMoeda(data?.plp_contato_whatsapp) : limparMoeda(dadosDetronic.whatsapp)}`} target="_blank" rel="noopener noreferrer">
                        Whatsapp: +55 {data?.plp_contato_whatsapp ?? dadosDetronic.whatsapp}
                    </a>

                    <a href={`mailto:${data?.plp_contato_email ?? dadosDetronic.email}`} target="_blank" rel="noopener noreferrer">
                        Email: {data?.plp_contato_email ?? dadosDetronic.email}
                    </a>
                </div>
            </div>

            <p className="color-gray-700 mb-0 hh-20 text-center" style={{ paddingBottom: "16px" }}>
                Detronic Energia. Tecnologia que transforma, sustentabilidade que inspira.
            </p>
        </footer>
    );
}
